export default {
    isLoading: state => state.is_loading,
    file: state => state.file,
    projectId: state => state.project_id,
    allFiles: state => state.files.all,
    projectFiles: state => state.files.project,
    shareFiles: state => state.files.share,

    originalFilename: state => state.original_filename,

    maxProjectFiles: state => state.files.max_project_upload,
};



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/store/_getters.js